import {
  ConfirmDialog,
  ConfirmDialogProps,
  LinearProgress,
  Typography,
} from '@occc/ui-design-system';

export type SurveyConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  title: string;
  confirmButtonText: string;
  confirmButtonColor: ConfirmDialogProps['confirmButtonProps']['color'];
  description: string;
};

export const SurveyConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  title,
  confirmButtonText,
  confirmButtonColor,
  description,
}: SurveyConfirmDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle={title}
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText={confirmButtonText}
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
        color: confirmButtonColor,
      }}
    >
      {loading && <LinearProgress />}
      <Typography>{description}</Typography>
    </ConfirmDialog>
  );
};
